module.exports = __webpack_public_path__ + "static/media/fa-solid-900.a7140145.woff";